__turbopack_context__.v({
  "active": "message-vote-buttons-module-scss-module__R-cC3G__active",
  "vote-button": "message-vote-buttons-module-scss-module__R-cC3G__vote-button",
  "vote-buttons": "message-vote-buttons-module-scss-module__R-cC3G__vote-buttons",
});
